import { withTranslation } from "react-i18next";
import { Button, Input, Label, Modal, ModalBody, ModalHeader, Spinner,  } from "reactstrap";
import GroupedFieldsAccordion from "./GroupedFieldsAccordion";
import { useEffect, useState } from "react";
import { isJson } from "utils";
import { ApplicationState } from "store";
import { useSelector } from "react-redux";

const SectionsArrrangeModal = ({ props, show, onCloseClick, viewname, setViewname, onChange, groups,view , loading}: any) => {
    const userProfile = useSelector((state: ApplicationState) => state.auth.userProfile);
    const [error, setError] = useState(false);
    const [fields, setFields]  = useState<any>([])
    const [editSteps, setEditSteps]  = useState<any>([])

    const onApply = () => {
        onChange(fields, viewname, view?.id)
    }


    const handleViewAccess = (permissionJson: any) => {
        let userRole = userProfile?.role?.title;
        let roleid = userProfile?.role?.id;
        const permissions = permissionJson?.permissions;
        if (userRole === "Owner") return true
        else if (permissions) {
            switch (permissions) {
                case "Owner":
                case "owner": if (userRole === "Owner") return true;
                else return false;
                case "view": return true;
                case "view_edit": return true;
                case "role_based": const items = permissionJson.item || [];
                    let filteredId = items.filter((subitem: any) => subitem.role_id.toString() === roleid)
                    let isview = filteredId.filter((subitem: any) => (subitem.permission === "view" || subitem.permission === "view_edit"));
                    return isview && isview.length;
                default: return false;
            }

        }
    }
    const handleEditAccess = (permissionJson: any) => {
        let userRole = userProfile?.role?.title;
        let roleid = userProfile?.role?.id;
        const permissions = permissionJson?.permissions;
        if (userRole === "Owner") return true
        else if (permissions) {
            switch (permissions) {
                case "Owner":
                case "owner": if (userRole === "Owner") return true;
                else return false;
                case "view": return false;
                case "view_edit": return true;
                case "role_based": const items = permissionJson.item || [];
                    let filteredId = items.filter((subitem: any) => subitem.role_id.toString() === roleid)
                    let isview = filteredId.filter((subitem: any) => (subitem.permission === "view_edit"));
                    return isview && isview.length;
                default: return false;
            }

        }
    };

    useEffect(() => {
        let steps: any = [];
        setViewname(view?.name)
        let newFields: any = view && view?.fields && isJson(view?.fields) ? JSON.parse(view?.fields) : view?.fields;
        if(newFields?.length) {
            const keys = newFields?.length ? newFields?.map((obj: any) => Object.keys(obj)[0]) : []
            keys?.length && keys.map((id: any,index: any) => {
                let field = newFields?.[index]?.[id]
                let extras  = newFields?.[index]?.extras
                groups && groups.length  && groups.map((item: any, index: any) => {
                        if(id === item?.id) {
                            const parsedFields = item && item.metadata && item.metadata.map((meta: any) => ({
                                ...meta,
                                valuesJson: isJson(meta.valuesJson) ? meta.valuesJson : "{}"
                            }));
                            let newstatusMetaData: any = [];
                            field?.length && field?.map((sectionField: any) => {
                                parsedFields && parsedFields.map((field: any) => {
                                    if(sectionField?.id === field?.id) {
                                        let statusField = field?.valuesJson && isJson(field?.valuesJson) ? JSON.parse(field?.valuesJson) : {}
                                        let permissionsJson = field?.permissionsJson && isJson(field?.permissionsJson) ? JSON.parse(field?.permissionsJson) : {}
                                        let isFieldviewaccess = permissionsJson && permissionsJson.permissions ? handleViewAccess(permissionsJson) : true;
                                        let isFieldEditaccess = permissionsJson && permissionsJson.permissions ? handleEditAccess(permissionsJson) : true;
                                        if (isFieldviewaccess && !statusField?.process_flows) {
                                            if (isFieldEditaccess) {
                                                let newField = { ...field, isEditAccess: true, extras: {...field.extras,hideinView: sectionField?.extras?.hideinView }}
                                                return newstatusMetaData.push(newField)
                                            }
                                            return newstatusMetaData.push({...field, extras: {...field.extras,hideinView: sectionField?.extras?.hideinView }})
                                        }
                                    }
                                })
                            })
                            steps.push({
                                id: item?.id,
                                label: item.groupTitle,
                                tab: (index + 1).toString(),
                                fields: newstatusMetaData,
                                extras: extras
                            });
                            }
                    })
            })
            const existingIds = new Set(keys); // convert to Set for faster lookup
            groups?.forEach((item: any, index: number) => {
                if (!existingIds.has(item?.id)) {
                    const parsedFields = item && item.metadata && item.metadata.map((meta: any) => ({
                        ...meta,
                        valuesJson: isJson(meta.valuesJson) ? meta.valuesJson : "{}"
                    }));
                    let newstatusMetaData: any = [];
                    parsedFields && parsedFields.map((field: any) => {
                        let statusField = field?.valuesJson && isJson(field?.valuesJson) ? JSON.parse(field?.valuesJson) : {}
                        let permissionsJson = field?.permissionsJson && isJson(field?.permissionsJson) ? JSON.parse(field?.permissionsJson) : {}
                        let isFieldviewaccess = permissionsJson && permissionsJson.permissions ? handleViewAccess(permissionsJson) : true;
                        let isFieldEditaccess = permissionsJson && permissionsJson.permissions ? handleEditAccess(permissionsJson) : true;
                        if (isFieldviewaccess && !statusField?.process_flows) {
                            if (isFieldEditaccess) {
                                let newField = { ...field, isEditAccess: true, extras: { ...field?.extras, key: statusField?.label, hideinView: true} }
                                return newstatusMetaData.push(newField)
                            }
                            return newstatusMetaData.push(field)
                        }
                    })
                    steps.push({
                        id: item?.id,
                        label: item.groupTitle,
                        tab: (index + 1).toString(),
                        fields: newstatusMetaData,
                        extras: { ...item?.extras, key: item?.label, hideinView: true}
                    });
                    }
                });
        }

        setEditSteps(steps)
    }, [groups,view])
    


    return (
        <Modal backdrop="static" size='xl' className='modal-fullscreen' isOpen={show} toggle={onCloseClick} centered={true}>
                <ModalHeader className="p-3 offcanvas-header-dark d-flex flex-row justify-content-between align-items-center bg-primary" toggle={onCloseClick}>
                    <span className='text-light'>{props.t("common.modals.update_view")}</span>
                </ModalHeader>
                <ModalBody className='text-center p-5'>
                    <div className="vstack gap-1 py-2 text-left">
                            <Label>
                                View Name <span className="fw-bold text-danger">*</span>
                            </Label>
                            <Input
                                type="text"
                                className="form-control w-100"
                                placeholder="Enter View name"
                                value={viewname}
                                onChange={(e: any) => setViewname(e.target.value)}
                            />
                            {error && (
                                <p className="text-danger p-1">View with same name already exists</p>
                            )}
                    </div>
                    <GroupedFieldsAccordion
                        steps={editSteps}
                        onReorder={setEditSteps}
                        setFields={setFields}
                    />
                </ModalBody>

                <div className="offcanvas-footer bg-opacity-10 border-top p-3 justify-content-center hstack gap-2">
                    <Button
                        className="btn btn-success w-auto"
                        onClick={() => onApply()}
                        disabled={!viewname || error || loading}
                    >
                        {loading ? <Spinner size="sm" className="flex-shrink-0">Loading... </Spinner> :  null}
                        <span className='text-light'>{props.t("common.modals.update_view")}</span>
                    </Button>
                    <Button color="danger" onClick={() => onCloseClick()} outline>
                        {props.t("common.offcanvas.import_cancel")}
                    </Button>
                </div>
        </Modal>
    ) as unknown as JSX.Element;
};

export default withTranslation()(SectionsArrrangeModal);